import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Division } from '../models/division-model';

/**
 * Class that handle the call to division rest services
 * @author Castor Transformación Digital - Juan G. Pavas
 * @since 2019-12-02
 */
@Injectable({
    providedIn: 'root'
})
export class DivisionService {

    private API_DIVISION_URL = environment.ipserver + 'o2c-backend/private/common/listDivision';

    constructor(
        private httpClient: HttpClient
    ) { }

    /**
     * Method that obtains a list of divisions by calling division rest service
     * @author Castor Transformación Digital - Juan G. Pavas
     * @since 2019-12-02
     * @return Observable with a json that contains a list of divisions
     */
    public getAllDivisions(): Observable<Division[]> {
        return this.httpClient.get<Division[]>(this.API_DIVISION_URL);
    }

    /**
     * Sorts any division by it's division code
     * @param data Array of objects (divisions) to be ordered
     * @author Castor Transformación Digital - Andrés Montilla
     * @since 2020-09-22
     */
    sortDivisions(data: Division[]) {
        return data.sort((t1, t2) => {
            const name1 = t1.division;
            const name2 = t2.division;
            if (name1 > name2) { return 1; }
            if (name1 < name2) { return -1; }
            return 0;
        });
    }
}
